import img from "../img_us/4Protection solaire architecturale UNIK SYSTEM avec brise-soleil extérieur design moderne (5).webp";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function UsFilmSolairePage() {

  useEffect(() => {
    // Animation
    AOS.init({
      duration: 1500,
      once: true,
    });

   
  }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>FILM</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">Films solaires pour vitrages</h1>

          <p data-aos="fade-up">
            Films techniques en polyester ultra transparent conçus pour
            améliorer le confort thermique et visuel des espaces.
            Solution discrète, durable et performante pour vitrages
            résidentiels et professionnels.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-technique-us-film-solaire.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche technique
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US Film solaire vitrage" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que la solution US FILM Solaire ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            US FILM Solaire est une solution de films techniques appliqués
            directement sur les vitrages. Fabriqués à partir d’un polyester
            évolué ultra transparent, ces films sont solides et durables.
          </p>

          <p data-aos="fade-up">
            Ils permettent de réduire la chaleur, contrôler l’éblouissement
            et protéger les espaces contre les rayons UV tout en conservant
            la luminosité naturelle.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature icon="☀️" title="Protection solaire" text="Réflexion et absorption de la chaleur solaire." />
          <Feature icon="😎" title="Anti-éblouissement" text="Réduction de l’éblouissement tout en gardant la lumière." />
          <Feature icon="🛡️" title="Protection UV" text="Blocage des rayons UV nocifs." />
          <Feature icon="🧱" title="Renforcement du vitrage" text="Empêche le verre d’éclater en cas d’impact." />
          <Feature icon="✨" title="Anti-rayures" text="Traitement de surface résistant aux rayures." />
          <Feature icon="⚡" title="Installation rapide" text="Pose sans travaux lourds." />
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section">
        <SectionTitle small="Technique" big="Caractéristiques techniques" />

        <ul data-aos="fade-up" className="us-list">
          <li>Film polyester ultra transparent</li>
          <li>Épaisseur de quelques microns</li>
          <li>Résistance à la décoloration</li>
          <li>Réduction de la chaleur solaire</li>
          <li>Contrôle de l’éblouissement</li>
          <li>Protection contre les rayons UV</li>
          <li>Traitement anti-rayures</li>
        </ul>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Besoin d’une protection solaire efficace ?</h2>
        <p>Nos équipes vous accompagnent dans votre projet.</p><br/>
        <a href="/contact" className="btn-primarya">
          Contactez-nous
        </a>
      </section>

    </div>
  );
}
